import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";

import { useGetOrg } from "@src/api/organizations/get-organization";
import { useGetOrgList } from "@src/api/organizations-list/get-organization-list";
import { useSwitchOrganization } from "@src/api/organizations/switch-organization";
import { IgStorage } from "@src/utils/igStorage";

export const useSyncOrgFromUrl = () => {
  const { id: urlOrgId } = useParams<{ id: string }>();
  const organization = useGetOrg();
  const orgList = useGetOrgList();
  const location = useLocation();
  const switchOrganization = useSwitchOrganization(
    location.pathname + location.search
  );

  const currentOrgId = organization.data?.org.id;

  useEffect(() => {
    if (
      !urlOrgId ||
      !currentOrgId ||
      urlOrgId === currentOrgId ||
      switchOrganization.isPending
    ) {
      return;
    }

    const targetOrg = orgList.data?.orgs?.find((org) => org.id === urlOrgId);
    const token = IgStorage.authToken;

    if (!targetOrg || !token) {
      return;
    }

    switchOrganization.mutate({ token, orgId: urlOrgId });
  }, [currentOrgId, orgList, switchOrganization, urlOrgId]);
};
